import { render, staticRenderFns } from "./KoioteImageSwitchHover.vue?vue&type=template&id=c7ada55e&lang=es"
import script from "./KoioteImageSwitchHover.vue?vue&type=script&lang=js"
export * from "./KoioteImageSwitchHover.vue?vue&type=script&lang=js"
import style0 from "./KoioteImageSwitchHover.vue?vue&type=style&index=0&id=c7ada55e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports